import React, { useState } from 'react';
import { Row, Col, Button } from 'antd';
import { SearchInput } from 'src/components/inputs/SearchInput';
import { useTranslation } from 'react-i18next';
import { textFrom } from 'src/utils/textFrom';
import debounce from 'lodash/debounce';
import { Chips } from 'src/components/Chips';
import { useCollectionGroups } from '../provider/collectionGroups.provider';
import { CollectionGroupTable } from './collection-group/CollectionGroupTable';

export const SearchCollectionGroups = ({ collectionGroups, setLinkedCollectionGroups, mapper }) => {
  const { t } = useTranslation();
  const text = textFrom('components.searchCollectionGroups', t);
  const textFilter = textFrom('constants.filter', t);

  const { pagination, onChangeGroupsQuery, groupsQuery, areGroupsLoading } = useCollectionGroups();

  const [selectedKeys, setSelectedKeys] = useState([]);

  const addSelectedGroups = () => {
    const selectedGroups = selectedKeys.map(key => collectionGroups.find(collection => collection.id === key));
    const newSelectedGroups = mapper ? selectedGroups.map(mapper) : selectedGroups;
    setLinkedCollectionGroups(prev => [...prev, ...newSelectedGroups]);
    setSelectedKeys([]);
  };

  const handleSearchGroupFilter = (text) => {
    onChangeGroupsQuery({ ...groupsQuery, text: text });
  };

  const onTableChange = ({ current, pageSize }) => {
    onChangeGroupsQuery({ current, pageSize });
  };

  const onTagRemove = () => {
    handleSearchGroupFilter('');
  };

  const CollectionGroupSearch = () => (
    <SearchInput
      defaultValue={groupsQuery?.text}
      placeholder={text('searchPlaceholder')}
      onChangeText={debounce((value) => handleSearchGroupFilter(value), 500)}
    />
  );

  return (
    <>
      <Row justify='space-between'>
        <Col flex='1' span={4}>
          {text('searchLabel')}
          <CollectionGroupSearch />
        </Col>
        <Col>
          <Button
            type='primary'
            className='uppercase mt-5'
            onClick={addSelectedGroups}
          >
            {text('add')}
          </Button>
        </Col>
      </Row>
      {!!groupsQuery?.text &&
        <Row className='py-4'>
          <div className='pr-2'>{textFilter('appliedFilter', { count: +(!!groupsQuery.text && +1) })}:
            <Chips
              query={groupsQuery}
              chipKeys={['text']}
              onTagRemove={onTagRemove}
            />
          </div>
        </Row>}
      <CollectionGroupTable
        isEditModeOn
        className='pt-8'
        loading={areGroupsLoading}
        collections={collectionGroups}
        pagination={pagination}
        onTableChange={onTableChange}
        selectedCollectionGroupKeys={selectedKeys}
        setSelectedCollectionGroupKeys={setSelectedKeys}
      />
    </>
  );
};
